module.exports = __webpack_public_path__ + "static/RigiTv-d6d3a12bafc90427b0bcc58cab54e24d.png";